"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var config_1 = require("@pbl/pbl-react-web-components/lib/config/config");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var styles_1 = __importDefault(require("./styles"));
var TicketHelpModal = function (_a) {
    var visible = _a.visible, onDismiss = _a.onDismiss, initialTabKey = _a.initialTabKey, tabs = _a.tabs, displayVideo = _a.displayVideo, _b = _a.withDialogTitle, withDialogTitle = _b === void 0 ? true : _b;
    var t = (0, react_i18next_1.useTranslation)().t;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var _c = (0, react_1.useState)(initialTabKey), currentTabKey = _c[0], setCurrentTabKey = _c[1];
    (0, react_1.useEffect)(function () {
        setCurrentTabKey(initialTabKey);
    }, [initialTabKey]);
    var currentTab = (0, react_1.useMemo)(function () { return tabs.find(function (tab) { return tab.tabKey === currentTabKey; }); }, [tabs, currentTabKey]);
    var visibleTabs = (0, react_1.useMemo)(function () { return tabs.filter(function (tab) { return !!tab.tabTitle; }); }, [tabs]);
    var handleButtonChange = function (newTabKey) {
        setCurrentTabKey(newTabKey);
    };
    var dialogTitleText = (currentTab === null || currentTab === void 0 ? void 0 : currentTab.parentCardName)
        ? t('ticketEntryPage.helperImageTitle', {
            tabName: currentTab.parentCardName ? t(currentTab.parentCardName) : ''
        })
        : t('ticketEntryPage.helperImageTitle', 'Where do I find the information?');
    return (react_1.default.createElement(core_1.Dialog, { "aria-labelledby": "dialog-title", "aria-describedby": "dialog-description", fullWidth: true, maxWidth: "md", open: visible, className: classes.dialogBackdrop, PaperProps: {
            className: classes.dialog
        } },
        react_1.default.createElement(core_1.DialogTitle, { id: "dialog-title", "aria-live": "assertive", disableTypography: true, style: { padding: 0 } },
            react_1.default.createElement(core_1.Box, { display: "grid", gridTemplateColumns: "auto 1fr auto", width: "100%" },
                react_1.default.createElement(core_1.Box, { style: { width: '24px' } }),
                react_1.default.createElement(core_1.Box, { textAlign: "center" }, withDialogTitle && (react_1.default.createElement(core_1.Typography, { component: "h2", variant: "h6" }, dialogTitleText))),
                react_1.default.createElement(core_1.Box, null,
                    react_1.default.createElement(core_1.IconButton, { style: { padding: 0 }, "aria-label": "close", onClick: onDismiss },
                        react_1.default.createElement(Close_1.default, null))))),
        react_1.default.createElement(core_1.Box, { style: { display: 'flex', flexDirection: 'column', gap: theme.spacing(3) } },
            visibleTabs.length > 0 && (react_1.default.createElement(core_1.Box, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    paddingTop: theme.spacing(3)
                } }, visibleTabs.map(function (tab) {
                return currentTabKey === tab.tabKey ? (react_1.default.createElement(core_1.Button, { key: tab.tabKey, onClick: function () { return handleButtonChange(tab.tabKey); }, color: "primary", variant: "contained", style: {
                        margin: 0,
                        borderRadius: '24px',
                        letterSpacing: '1.3px',
                        fontWeight: 600,
                        lineHeight: '150%'
                    }, "aria-label": "view ".concat(t(tab.tabTitle), " of ticket") }, t(tab.tabTitle))) : (react_1.default.createElement(core_1.Button, { key: tab.tabKey, onClick: function () { return handleButtonChange(tab.tabKey); }, variant: "outlined", style: {
                        margin: 0,
                        borderRadius: '24px',
                        letterSpacing: '1.3px',
                        fontWeight: 600,
                        lineHeight: '150%'
                    }, "aria-label": "view ".concat(t(tab.tabTitle), " of ticket") }, t(tab.tabTitle)));
            }))),
            react_1.default.createElement(core_1.DialogContent, { id: "dialog-description", className: classes.dialogContent }, currentTab && (react_1.default.createElement(core_1.Box, null, displayVideo ? (react_1.default.createElement("div", { style: { textAlign: 'center' } },
                react_1.default.createElement("video", { controls: true, autoPlay: true, loop: true, key: currentTab.tabKey },
                    react_1.default.createElement("source", { src: currentTab.sampleImage, title: t('ticketEntry.helperImageDescription', "The \"Game-Pack-Ticket Number\" can be found behind the ticket right above the barcode. And the \"Entry Code\" can be found on the front of the scratched ticket right next to the barcode") }),
                    t('ticketEntry.noVideoSupport', "Sorry, your browser doesn't support embedded videos.")))) : (react_1.default.createElement(core_1.Box, { style: { width: '100%', height: '300px' } },
                react_1.default.createElement("img", { src: currentTab.sampleImage, alt: 'Ticket guide', style: {
                        height: '100%',
                        width: 'auto',
                        objectFit: 'contain',
                        display: 'block',
                        margin: '0 auto'
                    } })))))),
            (currentTab === null || currentTab === void 0 ? void 0 : currentTab.imageDescription) && (react_1.default.createElement(core_1.Typography, { style: { fontSize: '16px', lineHeight: '150%', letterSpacing: '0.3px' } }, t(currentTab.imageDescription))),
            react_1.default.createElement(core_1.DialogActions, { style: { padding: 0 } },
                react_1.default.createElement(core_1.Button, { onClick: onDismiss, color: config_1.config.internalConfig.BUTTON_BACKGROUND, variant: "contained", style: { margin: 0, width: '120px', height: '48px' } }, "OK")))));
};
exports.default = TicketHelpModal;
//# sourceMappingURL=TicketHelpModalV2.js.map